"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BROADCAST_CHANNEL = exports.BROADCAST_CHANNEL = "launchDarkly";


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/react-launch-darkly/build/constants/LaunchDarkly.js
// module id = 983
// module chunks = 69